import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/value/standard-48-poe.png";
import type { Product } from "../../types";
import { productListSwitchingValue } from "../product-list-groups/productListSwitchingValue";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const standard48PoE: Product = {
  id: "standard48PoE",
  productTitle: "Standard 48 PoE",
  description: "standard48poe.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-48-poe"],
  storePathParts: { productSlug: "usw-48-poe", category: "switching-standard" },
  sku: "USW-48-PoE",
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingValue,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 285 x 44 mm\n(17.4 x 11.2 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "48" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe+",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "195 W" },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },

    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
